import React from "react";
import bodyHelperTypes from "../../../utils/BodyHelperTypes";
import UnorderedList from "../../../layouts/bodyLayouts/helpers/UnorderedList";

const eCMH_Content = [
    
    {
        format: bodyHelperTypes.title,
        order: 10,
        content: "Program History and Description"

    },
    {
        format: bodyHelperTypes.paragraphs,
        order: 20,
        content: [
            "Kentucky's Early Childhood Mental Health Program (ECMHP) was established in state fiscal year 2003 as a component of a large, statewide early childhood development initiative, Kentucky Invests in Developing Success NOW (KIDS NOW). Programs created under KIDS NOW fit within three broad areas: assuring maternal and child health; supporting families; and enhancing early care and education. The majority of the programs have been sustained and are administered by a variety of state agencies.",
            "The ECMHP is co-administered by the Department for Behavioral Health, Developmental and Intellectual Disabilities (DBHDID) and the Department for Public Health (DPH) through a Memorandum of Agreement.",
            "In turn, DBHDID contracts with the 14 Regional Community Mental Health Centers (CMHCs) for program implementation."
        ]

    },
    {
        format: bodyHelperTypes.title,
        order: 30,
        content: "Program Goals"

    },
    {
        format: bodyHelperTypes.paragraphs,
        order: 40,
        content: [
            "The overarching goal of ECMHP is to build regional capacity to effectively identify and respond to the mental health needs of children age birth through age five in behavioral health provider agencies, early care and education settings, and other programs and initiatives that serve very young children and their families. This is accomplished through three primary activities:",
            <UnorderedList items={[
                "Program- and child-level consultation related to social, emotional, and behavioral issues to programs that serve children from birth through age five.",
                "Training on working with young children who have social, emotional and behavioral needs and their families provided to child-serving agencies and others.",
                "Evaluation, assessment, and therapeutic services for children from birth through age five and their families."
            ]} />
        ]

    },
    {
        format: bodyHelperTypes.title,
        order: 50,
        content: "Early Childhood Mental Health Specialists"


    },
    {
        format: bodyHelperTypes.paragraphs,
        order: 60,
        content: [
            "Each regional CMHC employs an Early Childhood Mental Health Specialist whose time is devoted solely to their regional ECMHPs and is focused on the three activities listed above in order to improve the mental health of children birth through age five and their families.",
            "In recent years, the ECMHP has expanded to include a focus on supporting infants, young children, and families impacted by opioid and other substance use disorders, with a focus on infants and young children identified as having been exposed to substance in utero. To address this growing need, DBHDID added funds to CMHC contracts to support Early Childhood Consultants as an additional staff person dedicated to regional ECMHPs."
            // "Improving the behavioral health of children birth through age five and their families. "
        ]


    },
    {
        format: bodyHelperTypes.title,
        order: 70,
        content: "Early Childhood Consultants "


    },
    {
        format: bodyHelperTypes.paragraphs,
        order: 70,
        content: [
            "Like the Early Childhood Mental Health Specialists, the Early Childhood Consultants are located in each of the 14 regional CMHCs. The Early Childhood Consultants also focus on the population of children age birth through five, and their families, specifically those who are experiencing challenges related to substance use disorders. They are responsible for increasing regional capacity to identify and serve infants who experienced in utero substance exposure; have had or are at risk for trauma exposure; and young children whose mothers are recovering from substance use disorders. This is achieved through consultation, training, and collaboration focused on mitigating the effects of adverse childhood experiences and improving early childhood development and attachment.",
            // "The Early Childhood Consultants are responsible for increasing regional capacity for early childhood education and consultation regarding substance exposed infants and trauma exposed youth whose mothers are recovering from OUD to mitigate adverse childhood experiences and improve early childhood development and attachment. ",
            "To obtain more information about your local ECMHP, please use the ECMH Contacts List."
        ]


    },
   



            

           
    


];

export default eCMH_Content;